"use client";

import { usePathname } from "next/navigation";

/* eslint-disable react/jsx-no-literals */
export const DraftModeNotice = () => {
	const pathname = usePathname();

	return (
		<div className="fixed bottom-0 z-50 w-full bg-brand-highlight-hover p-4 text-center text-base font-bold text-white">
			Sie sehen hier die unveröffentlichte Version dieser Seite.{` `}
			<a
				href={`/api/cms/draft/disable?redirectTo=${encodeURIComponent(pathname)}`}
				className="underline"
			>
				Verlassen
			</a>
		</div>
	);
};

// 🔬 TBD
